import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CbDialogModule } from '@app/shared/components/dialog/dialog.module';
import { CbFormsModule } from '@app/shared/components/forms/forms.module';
import { CbDatePipeModule } from '@app/shared/pipe/date/date.module';
import { CbInfoMessageModule, CbLoadingSpinnerModule } from 'cb-hub-lib';
import { NonWorkingDayDialogComponent } from './non-working-day-dialog/non-working-day-dialog.component';
import { NonWorkingDayLocationDialogComponent } from './non-working-day-location-dialog/non-working-day-location-dialog.component';
import { NonWorkingDaysComponent } from './non-working-days.component';

@NgModule({
    declarations: [
        NonWorkingDaysComponent,
        NonWorkingDayDialogComponent,
        NonWorkingDayLocationDialogComponent
    ],
    imports: [
        CommonModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        CbDialogModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatInputModule,
        MatTableModule,
        CbInfoMessageModule,
        CbLoadingSpinnerModule,
        CbFormsModule,
        CbDatePipeModule,
    ],
    exports: [
        NonWorkingDaysComponent
    ]
})
export class NonWorkingDaysSettingsModule { }
